import React from 'react';
import {CompassIcon, ShirtIcon, SparklesIcon} from '../../icons';

/**
 * Шаг «Приветствие» (слот 1): что соберёт мастер и зачем. Данных не собирает — сохраняется
 * сам факт старта, чтобы прогресс появился сразу и главная могла предложить продолжить.
 */
const HIGHLIGHTS = [
    {
        icon: <CompassIcon className="w-5 h-5 text-brand-600 dark:text-brand-400"/>,
        title: 'Стратегия гардероба',
        text: 'Система поймёт, что для вас «хорошо»: минимум вещей, капсула, офис или бюджет.',
    },
    {
        icon: <ShirtIcon className="w-5 h-5 text-brand-600 dark:text-brand-400"/>,
        title: 'Ваш стиль и размеры',
        text: 'Советы по образам и покупкам будут учитывать посадку и предпочтения.',
    },
    {
        icon: <SparklesIcon className="w-5 h-5 text-brand-600 dark:text-brand-400"/>,
        title: 'Первые вещи',
        text: 'Загрузите фото — карточки заполнит AI, гардероб не придётся вводить руками.',
    },
];

const StepWelcome: React.FC = () => (
    <div className="space-y-4" data-testid="onboarding-step-welcome">
        <ul className="space-y-3">
            {HIGHLIGHTS.map(item => (
                <li key={item.title} className="flex items-start gap-3">
                    <span className="mt-0.5 shrink-0">{item.icon}</span>
                    <span>
                        <span className="block text-sm font-semibold text-gray-900 dark:text-gray-100">
                            {item.title}
                        </span>
                        <span className="block text-sm text-gray-500 dark:text-gray-400">{item.text}</span>
                    </span>
                </li>
            ))}
        </ul>
        <p className="text-sm text-gray-500 dark:text-gray-400">
            Это займёт пару минут. Любой шаг можно пропустить, а настройку — прервать и продолжить позже.
        </p>
    </div>
);

export default StepWelcome;
